import SharedAppointments from "../../components/SharedAppointments"

export default function Shared() {
  return (
    <SharedAppointments
      fetchOnlyActive={true}
    />
  )
};